import { useEffect } from "react";
import { isSuccessRequest } from "../../../helpers/request-helper";
import { useMutation as useReactMutation, useQuery as useReactQuery } from "@tanstack/react-query";
import { QueryProps } from "./types";

export const useQueryCallbacks = (query, { enabled = true, onSuccess, onError }, isBlob = false) => {
    const { data, isLoading, isError, isSuccess, error } = query;

    useEffect(() => {
        if (!isLoading && enabled) {
            if (isSuccessRequest({ isError, isSuccess, data }, isBlob) && (isBlob || data?.data)) {
                if (onSuccess) { onSuccess(data); }
            } else if (onError) {
                onError(error);
            }
        }
    }, [data, enabled, isLoading, isError]);
};

export const useQuery = <TQueryFnData>({ queryKey, enabled, onSuccess, onError, isBlob, ...otherOptions }: QueryProps<TQueryFnData> & { onSuccess?: any, onError?: any, isBlob?: boolean}) => {
    const query = useReactQuery<TQueryFnData>({
        queryKey,
        enabled,
        ...otherOptions,
    });

    useQueryCallbacks(query, { enabled: !!enabled, onSuccess, onError }, isBlob);

    return { ...query, queryKey };
};

export const useMutation = (options) => {
    const mutation = useReactMutation(options);

    return {
        ...mutation,
        mutate: (params, { onSuccess, onError }: { onSuccess: any, onError: any }) => mutation.mutate(params, {
            onSuccess: (data: any) => {
                if (data?.success) {
                    if (onSuccess) { onSuccess(data); }
                } else if (onError) {
                    onError();
                }
            },
            onError,
        }),
    };
};

export const useMutationWithoutResponse = (options) => {
    const mutation = useReactMutation(options);

    return {
        ...mutation,
        mutate: (params, { onSuccess, onError }: { onSuccess: any, onError: any }) => mutation.mutate(params, {
            onSuccess,
            onError,
        }),
    };
};
